'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('HubStyleTokens/colors');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _UIButton = require('UIComponents/button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _Constants = require('../../Constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentHolder = (0, _styledComponents2.default)('div').withConfig({
  displayName: 'AvatarContentHolder__ContentHolder'
})(['align-items:center;border-radius:', ';box-sizing:border-box;color:', ';display:flex;font-size:initial;', ' height:', ';overflow:hidden;position:relative;width:', ';'], function (props) {
  return _Constants.AVATAR_TYPES[props.type] === _Constants.AVATAR_TYPES.productId ? '3px' : '50%';
}, _colors.OLAF, function (props) {
  return props._isListReversed && 'border: 2px solid ' + _colors.OLAF + ';';
}, function (props) {
  return props.size && props.size !== _Constants.AVATAR_SIZES.responsive ? _Constants.AVATAR_SIZES[props.size] + 'px' : 'inherit';
}, function (props) {
  return props.size && props.size !== _Constants.AVATAR_SIZES.responsive ? _Constants.AVATAR_SIZES[props.size] + 'px' : '100%';
});

var AvatarContentHolder = function AvatarContentHolder(props) {
  var href = props.href,
      children = props.children,
      size = props.size,
      type = props.type,
      _isListReversed = props._isListReversed;

  var avatarWidth = size === _Constants.AVATAR_SIZES.responsive ? '100%' : '$[size}';
  var avatarHeight = size === _Constants.AVATAR_SIZES.responsive ? '' : '$[size}';

  if (href) {
    return _react2.default.createElement(
      _UIButton2.default,
      {
        style: {
          width: avatarWidth,
          height: avatarHeight
        },
        use: 'unstyled',
        href: href
      },
      _react2.default.createElement(
        ContentHolder,
        {
          type: type,
          _isListReversed: _isListReversed,
          size: size
        },
        children
      )
    );
  }

  return _react2.default.createElement(
    ContentHolder,
    { type: type, _isListReversed: _isListReversed, size: size },
    children
  );
};

AvatarContentHolder.propTypes = {
  children: _propTypes2.default.node.isRequired,
  href: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(Object.keys(_Constants.AVATAR_SIZES)),
  type: _propTypes2.default.oneOf(Object.keys(_Constants.AVATAR_TYPES)),
  _isListReversed: _propTypes2.default.bool
};

exports.default = AvatarContentHolder;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-avatars/static-2.2292/js/UIAvatarDisplay/baseStyledComponents/AvatarContentHolder.js
// module id = 188
// module chunks = 177